import { render, staticRenderFns } from "./MoreActions.vue?vue&type=template&id=64d44072&lang=true"
import script from "./MoreActions.vue?vue&type=script&lang=js"
export * from "./MoreActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports